/**
 * Event Bridge: CustomEvents → Zustand Store
 *
 * Feuert IMMER das CustomEvent (Backward-Compat).
 * Wenn experimentalCaching aktiv, schreibt zusätzlich in den Zustand Store.
 */
import useDashboardStore from './useDashboardStore';

export function emitEvent(eventName, detail = {}) {
  // IMMER CustomEvent feuern (für Backward-Compat)
  window.dispatchEvent(new CustomEvent(eventName, { detail }));

  // Zusätzlich in Zustand wenn aktiviert
  const { experimentalCaching } = useDashboardStore.getState();
  if (experimentalCaching) {
    const store = useDashboardStore.getState();
    switch (eventName) {
      case 'refresh-data':
        store.triggerRefresh();
        break;
      case 'transport-complete':
        store.setTransportEvent(detail);
        break;
      case 'deploy-status':
        store.setDeployStatus(detail.instanceId, detail.flowId, detail.status);
        break;
      case 'cache-invalidated':
        store.invalidateCache(detail.instanceId);
        break;
      case 'cpi-nav-pd':
        store.setNavPdEvent(detail);
        break;
      case 'cpi-chat-prefill':
        store.setChatPrefillEvent(detail);
        break;
      default:
        // Unbekanntes Event - nur CustomEvent (bereits oben gefeuert)
        break;
    }
  }
}
